import type { VoidComponent } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import type { Group } from "../../../state/group";
import { useModalManager } from "../../../components/modal/ModalManager";
import { DestructiveModal } from "../../../components/modal/Modal";
import UserService from "../../../services/UserService";
import GenericFailureModal from "../../GenericFailureModal";
import { Translation } from "../../../utils/Translation";
import { keyFromSelector } from "i18next";
import type CustomerId from "../../../state/CustomerId";
import { useNavigate } from "@solidjs/router";

type DeleteGroupConfirmationModalProps = {
  customerId: CustomerId;
  group: Group;
};

const DeleteGroupConfirmationModal: VoidComponent<DeleteGroupConfirmationModalProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { replace } = useModalManager();

  return (
    <DestructiveModal
      confirmLabel={t(($) => $.DELETE_GROUP_CONFIRMATION_MODAL_ACTIONS_CONFIRM)}
      confirmLabelSlow={t(($) => $.DELETE_GROUP_CONFIRMATION_MODAL_ACTIONS_CONFIRM_SLOW)}
      cancelLabel={t(($) => $.DELETE_GROUP_CONFIRMATION_MODAL_ACTIONS_CANCEL)}
      title={t(($) => $.DELETE_GROUP_CONFIRMATION_MODAL_TITLE)}
      description={
        <Translation
          key={keyFromSelector(($) => $.DELETE_GROUP_CONFIRMATION_MODAL_DESCRIPTION)}
          options={{ name: props.group.name }}
          components={{
            b: (props) => <span class="text-base-semibold text-primary">{props.children}</span>,
          }}
        />
      }
      onConfirm={() => {
        const groupId = props.group.id;
        const customerId = props.customerId;

        return new Promise<void>((resolve, reject) =>
          UserService.deleteGroup(customerId, groupId).mutate(undefined, {
            onSuccess: () => {
              navigate(`/customers/${customerId}/groups`);
              resolve();
            },
            onError: (err) => {
              replace({
                content: () => <GenericFailureModal error={err} />,
              });
              reject(err);
            },
          }),
        );
      }}
    />
  );
};
export default DeleteGroupConfirmationModal;
